import React from "react";
import { useState, useEffect } from "react";
import "./DateTimeModal.css";

const ErrorText = ({ error }) => {
  if (!error) return null;
  return <p className="dt-error-text">{error}</p>;
};

const DateTimeModal = ({
  visible,
  onClose,
  onSave,
  initialValues = {},
  errors = {},
}) => {
  const [startDate, setStartDate] = useState(
    initialValues.startDate ? new Date(initialValues.startDate) : null
  );
  const [endDate, setEndDate] = useState(
    initialValues.endDate ? new Date(initialValues.endDate) : null
  );
  const [startTime, setStartTime] = useState(
    initialValues.startTime ? new Date(initialValues.startTime) : null
  );

  const [formErrors, setFormErrors] = useState({
    startDate: "",
    endDate: "",
    startTime: "",
  });

  useEffect(() => {
    if (startDate && endDate && endDate < startDate) {
      setEndDate(null);
      setFormErrors((prev) => ({
        ...prev,
        endDate: "End date cannot be before start date",
      }));
    }
  }, [startDate]);

  useEffect(() => {
    if (visible) {
      setStartDate(
        initialValues.startDate ? new Date(initialValues.startDate) : null
      );
      setEndDate(
        initialValues.endDate ? new Date(initialValues.endDate) : null
      );
      setStartTime(
        initialValues.startTime ? new Date(initialValues.startTime) : null
      );
    }
  }, [visible, initialValues]);

  useEffect(() => {
    setFormErrors(errors);
  }, [errors]);

  const handleSave = () => {
    let hasError = false;

    if (!startDate) {
      setFormErrors((prev) => ({ ...prev, startDate: "Required" }));
      hasError = true;
    }

    if (!endDate) {
      setFormErrors((prev) => ({ ...prev, endDate: "Required" }));
      hasError = true;
    }

    if (!startTime) {
      setFormErrors((prev) => ({ ...prev, startTime: "Required" }));
      hasError = true;
    }

    if (hasError) return;

    onSave({
      startDate,
      endDate,
      startTime,
    });
    onClose();
  };

  if (!visible) return null;

  return (
    <div className="dt-modal-overlay" onClick={onClose}>
      <div className="dt-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="dt-header">
          <div className="dt-header-bar"></div>
          <button onClick={onClose} className="dt-close-button">
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="dt-content-container">
          <div className="dt-title-container">
            <h2 className="dt-title">Additional Date & Time</h2>
            <p className="dt-subtitle">Enter start & end date and time</p>
          </div>

          <div className="dt-date-container">
            <div className="dt-date-section">
              <label className="dt-label">Start Date</label>
              <input
                type="date"
                className="dt-date-input"
                value={startDate ? startDate.toISOString().split("T")[0] : ""}
                onClick={(e) => e.target.showPicker()}
                onChange={(e) => {
                  setStartDate(new Date(e.target.value));
                  if (formErrors.startDate) {
                    setFormErrors((prev) => ({ ...prev, startDate: "" }));
                  }
                }}
              />
              <ErrorText error={formErrors.startDate} />
            </div>

            <div className="dt-date-section">
              <label className="dt-label">End Date</label>
              <input
                type="date"
                className="dt-date-input"
                value={endDate ? endDate.toISOString().split("T")[0] : ""}
                onClick={(e) => e.target.showPicker()}
                onChange={(e) => {
                  setEndDate(new Date(e.target.value));
                  if (formErrors.endDate) {
                    setFormErrors((prev) => ({ ...prev, endDate: "" }));
                  }
                }}
                min={startDate ? startDate.toISOString().split("T")[0] : ""}
              />
              <ErrorText error={formErrors.endDate} />
            </div>
          </div>

          <div className="dt-time-section">
            <label className="dt-label">Time</label>
            <input
              type="time"
              className="dt-time-input"
              value={startTime ? startTime.toTimeString().slice(0, 5) : ""}
              onChange={(e) => {
                const [hours, minutes] = e.target.value.split(":");
                const date = new Date();
                date.setHours(Number.parseInt(hours, 10));
                date.setMinutes(Number.parseInt(minutes, 10));
                setStartTime(date);
                if (formErrors.startTime) {
                  setFormErrors((prev) => ({ ...prev, startTime: "" }));
                }
              }}
            />
            <ErrorText error={formErrors.startTime} />
          </div>
        </div>

        <div className="dt-button-container">
          <button className="dt-back-button" onClick={onClose}>
            Back
          </button>
          <button className="dt-save-button" onClick={handleSave}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default DateTimeModal;
